module.exports = __webpack_public_path__ + "static/media/sqlite.b672cbe0.png";